module.exports = __webpack_public_path__ + "static/media/bullet_icon.2df92aad.svg";